import { Controller } from "stimulus"

// Presentation-only affordances for the server-rendered expense snapshot form:
// amount input formatting, the live running total, and hiding the prefill note
// once the member edits an amount. All content, calculation, and persistence
// belong to the server (DebtQuests::ExpenseSnapshotsController +
// ExpenseSnapshotPresenter); the form submits to /debt_quest/expense_snapshot
// and the insight screen is rendered by Rails from the persisted response.
export default class extends Controller {
  static get targets() {
    return ["row", "totalAmount", "amountInput", "revealButton", "prefillBanner"]
  }

  connect() {
    this.recalcTotal()
  }

  sanitizeAmount(event) {
    const input = event.target
    let cleaned = input.value.replace(/[^0-9.]/g, "")
    const firstDot = cleaned.indexOf(".")
    if (firstDot !== -1) {
      cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, "")
    }
    if (input.value !== cleaned) input.value = cleaned
    this._hidePrefillBanner()
    this.recalcTotal()
  }

  formatAmount(event) {
    const input = event.target
    const num = this._parse(input.value)
    if (num > 0) {
      // Locale pinned: the server strips everything but [0-9.], so a de/es
      // browser locale ("1.200,50") would round-trip as 1.2.
      input.value = "$" + num.toLocaleString("en-US")
    }
  }

  recalcTotal() {
    const total = this.rowTargets
      .reduce((sum, row) => sum + this._parse(row.querySelector("input")?.value), 0)
    this.totalAmountTarget.textContent = "$" + total.toLocaleString("en-US")
    this._setRevealDisabled(total <= 0)
  }

  // The prefill note (averages or autofill-applied) describes the seeded amounts;
  // once the member changes any editable amount it no longer holds, so drop it.
  // Only the note is targeted, so the linked-bank autofill CTA and divider stay.
  _hidePrefillBanner() {
    this.prefillBannerTargets.forEach(note => (note.hidden = true))
  }

  // The insight is meaningless with an all-zero snapshot: grey the reveal
  // submit out and block the click/submit until at least one amount is entered.
  _setRevealDisabled(disabled) {
    if (!this.hasRevealButtonTarget) return
    this.revealButtonTarget.disabled = disabled
    this.revealButtonTarget.classList.toggle("tw-opacity-50", disabled)
    this.revealButtonTarget.classList.toggle("tw-cursor-not-allowed", disabled)
    this.revealButtonTarget.classList.toggle("tw-cursor-pointer", !disabled)
  }

  _parse(value) {
    return Number((value || "").toString().replace(/[^0-9.]/g, "")) || 0
  }
}
